import { VodRowViewProps } from '@/types/vod/vodRow'
import {
    vodDetailsRequestKeyword,
    vodItemsRequestKeyword,
    vodPlaybacksRequestKeyword,
    vodRowsRequestKeyword,
    _defaultVodRowsCount,
    webType,
    externalType,
    vodType,
    catType,
    cutvType,
    vodItemDetailsAdverts,
    vodPlaybacksPositionRequestKeyword,
} from '@/shared/constants/vodConstants'

import { VodItemProps } from '@/types/vod/VodItem'

import { getErrorMessage } from '@/shared/lib/getErrorMessage'
import { IVODServiceToya } from '@/shared/services/types/vodService/vodServiceInterfaces'
import { AdvertPayload } from '@/types/vod/vodItemAdvert'
import { postWithAuth, putWithAuth } from '@/api/httpRequests'
import VodItem from '@/features/VOD/vodClasses/vodItem'

class VODServiceToya implements IVODServiceToya {
    getRows = async (
        rowId: string,
        start: string,
        rowCount?: number,
        profileId?: string
    ): Promise<VodRowViewProps[]> => {
        const count = rowCount || _defaultVodRowsCount
        const requestBody = JSON.stringify({
            rowId,
            start,
            count,
        })

        return await postWithAuth(
            vodRowsRequestKeyword,
            true,
            requestBody,
            profileId
        )
    }

    getAdverts = async (
        item: string,
        itemId: number
    ): Promise<AdvertPayload> => {
        const requestBody = JSON.stringify({
            item,
            itemId,
        })
        return await postWithAuth(vodItemDetailsAdverts, true, requestBody)
    }

    getItems = async (
        rowId: string | number,
        start: number,
        count: number,
        profileId?: string
    ): Promise<VodItem[]> => {
        const requestBody = JSON.stringify({
            rowId,
            start,
            count,
        })
        return await postWithAuth(
            vodItemsRequestKeyword,
            true,
            requestBody,
            profileId
        )
    }

    getPlaybacks = async (productId?: string, productType?: string) => {
        const requestBody = JSON.stringify({
            productId,
            productType,
        })

        const response = await postWithAuth(
            vodPlaybacksRequestKeyword,
            true,
            requestBody
        )
        return response
    }

    getPlaybacksPosition = async (
        productId: string,
        productType: string,
        position: number,
        profileId: string
    ) => {
        const requestBody = JSON.stringify({
            productId,
            productType,
            position,
        })
        const response = await putWithAuth(
            vodPlaybacksPositionRequestKeyword,
            true,
            requestBody,
            profileId
        )
        return response
    }

    getVodDetails = async (
        productId: string,
        assetType: string,
        profileId?: string
    ) => {
        const requestBody = JSON.stringify({
            productId,
            productType: assetType,
        })

        const response = await postWithAuth(
            vodDetailsRequestKeyword,
            true,
            requestBody,
            profileId
        )

        return response.details
    }

    getVodItems = async (
        rowId: string,
        start: number,
        count: number,
        profileId?: string
    ): Promise<VodItem[]> => {
        const apiRowItems = await this.getItems(rowId, start, count, profileId)

        return this.createItemsObjects(apiRowItems)
    }

    createItemsObjects = (itemsList: VodItemProps[]): VodItem[] => {
        if (!itemsList || !itemsList.length || !Array.isArray(itemsList))
            return []

        const validatedItems = itemsList.filter((apiItem: VodItemProps) => {
            if (apiItem.productType && apiItem.id) {
                const type = apiItem.productType
                if (type === webType || type === externalType) {
                    if (apiItem.externalUri) return apiItem
                } else {
                    if (type === vodType && apiItem.imageUrl && apiItem.title)
                        return apiItem
                    else if (type === catType && apiItem.title) {
                        return apiItem
                    } else if (type === cutvType) return apiItem
                }
            }
            return null
        })

        return validatedItems.map((item: VodItemProps) => new VodItem(item))
    }

    fetchRows(
        rowIndex: string,
        startIndex: number,
        profileId?: string
    ): Promise<VodRowViewProps[]> | undefined {
        try {
            return this.getRows(
                rowIndex,
                String(startIndex),
                undefined,
                profileId
            )
        } catch (error) {
            getErrorMessage('fetchRows', error)
        }
    }

    createId = (id: number | string) => id.toString()
    // id.toString().length === 1 ? `VOD:${id}` : id.toString()
}

export default new VODServiceToya()
